import React, { useState, useEffect, useContext } from 'react';
import { TokenContext } from './TokenProvider';
import { apiGetCompanionsFromSpotifyId } from '../../services/functionApp';

// import { useParams } from 'react-router-dom';
export const CompanionContext = React.createContext();

const CompanionProvider = ({children}) => {

  const [ getToken ] = useContext(TokenContext);
  const [ companionData, setCompanionData ] = useState(null);

  useEffect(() => {

    if (!getToken()) return;

    async function getCompanionData() {

      console.log("Gathering companion data")

      //Get user's companion data
      if (companionData == null) {
        const companionsResponse = await apiGetCompanionsFromSpotifyId(getToken());
        setCompanionData(companionsResponse);
      } 
      
    }

    getCompanionData();
  }, [ companionData, getToken() ])

  return (
    <CompanionContext.Provider value={[companionData, setCompanionData]}>
      {children}
    </CompanionContext.Provider>
  )

};

export default CompanionProvider;